import { AppThunkDispatch } from "@/store";
import networkHelper from "@/composables/network-helper";
import { logout } from "../store/slices/authSlice";

let dispatch: AppThunkDispatch | null = null;
let isLoggingOut = false;
const apiContextHelper = () => {
  let isRefreshingToken = false;
  const { getBaseUrl } = networkHelper();
  // ***** Constants *****
  const API_CONFIG = {
    baseURL: getBaseUrl(),
    timeout: 30000, // 30 seconds
    headers: {
      "Content-Type": "application/json",
      // "Cache-Control": "no-cache",
    },
  } as const;
  const RefreshTokenStatusCode = 428;

  const setDispatch = (currentDispatch: AppThunkDispatch) => {
    dispatch = currentDispatch;
  };

  const getDispatch = () => {
    return dispatch as AppThunkDispatch | null;
  };

  const setIsRefreshingToken = (value: boolean) => {
    isRefreshingToken = value;
  };

  const getIsRefreshingToken = () => {
    return isRefreshingToken;
  };
  const getUnStringified = (token: string | null): string => {
    return token?.replaceAll('"', "") ?? "";
  };

  const getToken = (): string | null => {
    const token = localStorage.getItem("authToken") || "";
    return token ?? null;
  };

  const createHeaders = (
    isNonAuthenticated: boolean,
    customHeaders: Record<string, string> = {},
  ): Record<string, string> => {
    const headers: any = {
      ...API_CONFIG.headers,
      ...customHeaders,
    };

    if (!isNonAuthenticated) {
      const token = getUnStringified(getToken());
      if (token) {
        headers["Authorization"] = `Token ${token}`;
      }
    }

    return headers;
  };

  const handleLogout = () => {
    if (isLoggingOut) return;
    isLoggingOut = true;

    // Save current user as previous_user before clearing (for potential recovery)
    const custom_previous_user_id = localStorage.getItem(
      "custom_previous_user_id",
    );
    const user_data = JSON.parse(localStorage.getItem("userData") || "{}");
    const previous_user = custom_previous_user_id
      ? { id: custom_previous_user_id }
      : user_data;

    // Only save previous_user if there's actual user data
    if (user_data && Object.keys(user_data).length > 0) {
      localStorage.setItem("previous_user", JSON.stringify(previous_user));
    }

    // Clear current user's auth data
    localStorage.removeItem("token");
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");

    dispatch?.(logout());
    isLoggingOut = false;
  };

  return {
    setDispatch,
    getDispatch,
    setIsRefreshingToken,
    getIsRefreshingToken,
    getUnStringified,
    getToken,
    createHeaders,
    handleLogout,
    API_CONFIG,
    RefreshTokenStatusCode,
  };
};

export default apiContextHelper;
